"use strict";

import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "placeholder", "name", "value", "apiUrl", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { AutoSuggest } from '@autoguru/overdrive';
import { memo, startTransition, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useSuburbLookup } from '../../lib/geolocation';
import { userCoordsOptionCode } from '../../lib/geolocation/useSuburbLookup';
import { SuburbSelectOption } from './SuburbSelectOption';
import { jsx as _jsx } from "react/jsx-runtime";
const useGpsOptionPayload = {
  code: 'USE_GPS'
};
const gpsOption = {
  text: 'Use my current location',
  payload: useGpsOptionPayload,
  skip: true
};
const suburbSuggestionToAutoSuggest = suggestion => ({
  text: suggestion.value,
  payload: suggestion.obj,
  code: suggestion.code
});
export const SuburbSelect = /*#__PURE__*/memo(_ref => {
  let {
      className = '',
      placeholder = 'Postcode or Suburb',
      name = 'location',
      value: incomingValue,
      apiUrl,
      onChange
    } = _ref,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  const [value, setValue] = useState(incomingValue);
  const [inputValue, setInputValue] = useState({
    text: value ? value.displayName : '',
    payload: null
  });
  const reset = () => {
    setInputValue({
      text: '',
      payload: null
    });
    onChange(null);
  };
  const valueChanged = update => {
    startTransition(() => {
      setInputValue(update);
      if (!(update !== null && update !== void 0 && update.text)) return void reset();
      if (update.payload) {
        // User has selected a value
        if (update.payload !== useGpsOptionPayload) {
          // Ignore if it's a gps request
          const selectedSuburb = _objectSpread(_objectSpread({}, update.payload), {}, {
            displayName: update.text,
            latitude: coords === null || coords === void 0 ? void 0 : coords.latitude,
            longitude: coords === null || coords === void 0 ? void 0 : coords.longitude
          });
          setValue(selectedSuburb);
          setInputValue(update);
          onChange(selectedSuburb);
        }
      } else if (update.text) {
        setQuery(update.text);
      }
    });
  };
  const {
    isError: geoLocationErrorOccurred,
    setQuery,
    isLoading,
    lookupByLocation,
    suggestions,
    coords
  } = useSuburbLookup({
    query: inputValue.text,
    apiUrl
  });
  const optionRenderer = useMemo(() => option => /*#__PURE__*/_jsx(SuburbSelectOption, {
    suggestion: option.value,
    highlighted: option.highlight,
    onGpsRequest: option.value.payload === useGpsOptionPayload ? lookupByLocation : null
  }), [lookupByLocation]);
  const shouldShowGPSOption = useGPSPermission();
  const [componentSuggestions, setComponentSuggestions] = useState([]);
  useEffect(() => {
    const arrayOfSuggestions = (suggestions !== null && suggestions !== void 0 ? suggestions : []).map(suburbSuggestionToAutoSuggest);
    const cooordsOption = arrayOfSuggestions.find(({
      code
    }) => code === userCoordsOptionCode);
    if (cooordsOption) {
      setComponentSuggestions([]);
      valueChanged(cooordsOption);
    } else setComponentSuggestions(shouldShowGPSOption && !geoLocationErrorOccurred ? [gpsOption].concat(_toConsumableArray(arrayOfSuggestions)) : arrayOfSuggestions);
  }, [suggestions, shouldShowGPSOption, geoLocationErrorOccurred]);
  return /*#__PURE__*/_jsx(AutoSuggest, _objectSpread(_objectSpread({
    className: className
  }, inputProps), {}, {
    isLoading: isLoading,
    name: name,
    placeholder: placeholder,
    value: inputValue,
    suggestions: componentSuggestions,
    itemRenderer: optionRenderer,
    onChange: valueChanged
  }));
});
const useGPSPermission = () => {
  // We true as most devices might now have this api
  const [shouldShow, setShouldShow] = useState(true);
  useLayoutEffect(() => {
    let isMounted = true;
    if ('permissions' in navigator) {
      navigator.permissions.query({
        name: 'geolocation'
      }).then(({
        state
      }) => {
        if (isMounted) setShouldShow(state === 'granted' || state === 'prompt');
      });
    }
    return () => {
      isMounted = false;
    };
  }, []);
  return shouldShow;
};